import { useState, useEffect } from "react";

const THEME_KEY = "monyx_theme";

export function useTheme() {
  const [isDark, setIsDark] = useState(() => {
    try { return localStorage.getItem(THEME_KEY) !== "light"; }
    catch { return true; }
  });

  useEffect(() => {
    const html = document.documentElement;
    if (isDark) {
      html.classList.remove("light");
    } else {
      html.classList.add("light");
    }
    try { localStorage.setItem(THEME_KEY, isDark ? "dark" : "light"); } catch {}
  }, [isDark]);

  const toggleTheme = () => setIsDark((v) => !v);

  return { isDark, toggleTheme };
}
